import { useDictionary } from 'src/hooks/useDictionary';
import { MultiListResultState } from 'src/hooks/useSearchPage/searchListState/types';

import ResultsSummary from 'components/BaseHelpers/ResultsSummary';

import {
  NewsInsightsSearchResultItem,
  NewsInsightsSearchSortValue,
} from '../../useNewsInsightsSearch';

export type NewsInsightsSearchResultsSummaryProps = {
  lists: Record<
    string,
    MultiListResultState<NewsInsightsSearchResultItem, NewsInsightsSearchSortValue>
  >;
  labels: Record<string, string>;
};

const NewsInsightsSearchResultsSummary = (
  props: NewsInsightsSearchResultsSummaryProps
): JSX.Element => {
  const { searchResultsReturnedLabel } = useDictionary();
  const { lists, labels } = props;
  const options = Object.entries(lists).map(([key, list]) => ({
    label: `${labels[key]} (${list.totalCount})`,
    onClick: () => {
      document.querySelector(`[data-section="${key}"]`)?.scrollIntoView({ behavior: 'smooth' });
    },
    disabled: list.totalCount === 0,
    selected: list.totalCount !== 0,
  }));

  return <ResultsSummary header={searchResultsReturnedLabel} options={options} />;
};

export default NewsInsightsSearchResultsSummary;
